var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowMark)?_c('div',{staticClass:"bbp-mark"},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")]):(_vm.isShowClockIcon)?_c('div',{staticClass:"bbp-mark bbp-mark_clock"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.CLOCK_ICON())}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae30c74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPMark/BBPMark.vue
// module id = null
// module chunks = 